import { AfterContentInit, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ca-compact-form-checkbox-item',
    templateUrl: './compact-form-checkbox-item.component.html',
    styleUrls: ['./compact-form-checkbox-item.component.scss'],
    standalone: false
})
export class CompactFormCheckboxItemComponent implements OnInit, AfterContentInit {
  @Input()
  autoWidth = false;

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    const el = this.elRef.nativeElement as HTMLElement;

    el.classList.add(this.autoWidth ? 'col-auto' : 'col');
  }
}
